<template>
    <Tooltip :is-disabled="!hasAllocations">
        <template #trigger="tooltipProps">
            <p
                :id="props.id"
                class="whitespace-nowrap uppercase text-xxs focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gray-700 rounded-xs tabular-nums select-none"
                :class="[hasOwnAllocations ? 'font-bold' : 'font-normal', { 'cursor-help': hasAllocations }]"
                v-bind="tooltipProps"
                :tabindex="0"
            >
                {{ props.label }}
                <span v-if="hasOwnAllocations" class="tabular-nums">
                    <template v-if="own.inRange === own.total">({{ own.total }})</template>
                    <template v-else>({{ own.inRange }}/{{ own.total }})</template>
                </span>
            </p>
        </template>

        <template #text>
            <OwnAndForeignAllocationCountTooltipText :allocation-count="props.allocationCount" />
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import type { OwnAndForeignAllocationCount } from '@/components/Timeline/logic/allocationCounts';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { computed } from 'vue';
import OwnAndForeignAllocationCountTooltipText from './OwnAndForeignAllocationCountTooltipText.vue';

type SectionOwnAndForeignAllocationCountLabelProps = {
    id: string;
    label: string;
    allocationCount: OwnAndForeignAllocationCount;
};

const props = defineProps<SectionOwnAndForeignAllocationCountLabelProps>();

const own = computed(() => props.allocationCount.own);
const hasOwnAllocations = computed(() => own.value.total > 0);
const hasAllocations = computed(() => hasOwnAllocations.value || props.allocationCount.foreign.inRange > 0);
</script>
